export function AppleNotesIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      id="Layer_1"
      version="1.1"
      viewBox="0 0 100 100"
      xmlSpace="preserve"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <defs>
        <linearGradient
          gradientTransform="matrix(62 0 0 18.5 56280 10390)"
          gradientUnits="userSpaceOnUse"
          id="SVGID_1_"
          x1="-906.9355"
          x2="-906.9355"
          y1="-561.3496"
          y2="-559.8502"
        >
          <stop offset="0" style={{ stopColor: '#FFDB4C' }} />
          <stop offset="1" style={{ stopColor: '#FFCD02' }} />
        </linearGradient>
      </defs>
      <g>
        {/* White fill paths */}
        <path
          fill="#FFFFFF"
          d="M5,36.4v18.1h90V36.4c0-1.3,0-2.5,0-3.7H5C5,33.8,5,35.1,5,36.4z M93.5,38c0.4,0,0.7,0.4,0.7,0.8   c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.4-0.7-0.8C92.8,38.3,93.1,38,93.5,38z M90.5,38c0.4,0,0.7,0.4,0.7,0.8c0,0.4-0.3,0.7-0.7,0.7   s-0.7-0.4-0.7-0.8C89.8,38.3,90.1,38,90.5,38z M87.5,38c0.4,0,0.7,0.4,0.7,0.8c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.4-0.7-0.8   C86.8,38.3,87.1,38,87.5,38z M84.5,38c0.4,0,0.7,0.4,0.7,0.8c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.4-0.7-0.8C83.8,38.3,84.1,38,84.5,38z    M81.5,38c0.4,0,0.7,0.4,0.7,0.8c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.4-0.7-0.8C80.8,38.3,81.1,38,81.5,38z M78.5,38   c0.4,0,0.7,0.4,0.7,0.8c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.4-0.7-0.8C77.8,38.3,78.1,38,78.5,38z M75.5,38c0.4,0,0.7,0.4,0.7,0.8   c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.4-0.7-0.8C74.8,38.3,75.1,38,75.5,38z M72.5,38c0.4,0,0.7,0.4,0.7,0.8c0,0.4-0.3,0.7-0.7,0.7   s-0.7-0.4-0.7-0.8C71.8,38.3,72.1,38,72.5,38z M69.5,38c0.4,0,0.7,0.4,0.7,0.8c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.4-0.7-0.8   C68.8,38.3,69.1,38,69.5,38z M66.5,38c0.4,0,0.7,0.4,0.7,0.8c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.4-0.7-0.8C65.8,38.3,66.1,38,66.5,38z    M63.5,38c0.4,0,0.7,0.4,0.7,0.8c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.4-0.7-0.8C62.8,38.3,63.1,38,63.5,38z M60.5,38   c0.4,0,0.7,0.4,0.7,0.8c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.4-0.7-0.8C59.8,38.3,60.1,38,60.5,38z M57.5,38c0.4,0,0.7,0.4,0.7,0.8   c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.4-0.7-0.8C56.8,38.3,57.1,38,57.5,38z M54.5,38c0.4,0,0.7,0.4,0.7,0.8c0,0.4-0.3,0.7-0.7,0.7   s-0.7-0.4-0.7-0.8C53.8,38.3,54.1,38,54.5,38z M51.5,38c0.4,0,0.7,0.4,0.7,0.8c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.4-0.7-0.8   C50.8,38.3,51.1,38,51.5,38z M48.5,38c0.4,0,0.7,0.4,0.7,0.8c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.4-0.7-0.8C47.8,38.3,48.1,38,48.5,38z    M45.5,38c0.4,0,0.7,0.4,0.7,0.8c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.4-0.7-0.8C44.8,38.3,45.1,38,45.5,38z M42.5,38   c0.4,0,0.7,0.4,0.7,0.8c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.4-0.7-0.8C41.8,38.3,42.1,38,42.5,38z M39.5,38c0.4,0,0.7,0.4,0.7,0.8   c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.4-0.7-0.8C38.8,38.3,39.1,38,39.5,38z M36.5,38c0.4,0,0.7,0.4,0.7,0.8c0,0.4-0.3,0.7-0.7,0.7   s-0.7-0.4-0.7-0.8C35.8,38.3,36.1,38,36.5,38z M33.5,38c0.4,0,0.7,0.4,0.7,0.8c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.4-0.7-0.8   C32.8,38.3,33.1,38,33.5,38z M30.5,38c0.4,0,0.7,0.4,0.7,0.8c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.4-0.7-0.8C29.8,38.3,30.1,38,30.5,38z    M27.5,38c0.4,0,0.7,0.4,0.7,0.8c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.4-0.7-0.8C26.8,38.3,27.1,38,27.5,38z M24.5,38   c0.4,0,0.7,0.4,0.7,0.8c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.4-0.7-0.8C23.8,38.3,24.1,38,24.5,38z M21.5,38c0.4,0,0.7,0.4,0.7,0.8   c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.4-0.7-0.8C20.8,38.3,21.1,38,21.5,38z M18.5,38c0.4,0,0.7,0.4,0.7,0.8c0,0.4-0.3,0.7-0.7,0.7   s-0.7-0.4-0.7-0.8C17.8,38.3,18.1,38,18.5,38z M15.5,38c0.4,0,0.7,0.4,0.7,0.8c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.4-0.7-0.8   C14.8,38.3,15.1,38,15.5,38z M12.5,38c0.4,0,0.7,0.4,0.7,0.8c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.4-0.7-0.8C11.8,38.3,12.1,38,12.5,38z    M9.5,38c0.4,0,0.7,0.4,0.7,0.8c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.4-0.7-0.8C8.8,38.3,9.1,38,9.5,38z M6.5,38c0.4,0,0.7,0.4,0.7,0.8   c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.4-0.7-0.8C5.8,38.3,6.1,38,6.5,38z"
        />
        <path
          fill="#FFFFFF"
          d="M6.5,82c2,5.4,6.1,9.5,11.5,11.5C22.9,95,27.4,95,36.4,95h27.2c9,0,13.5,0,18.5-1.6c5.3-1.9,9.5-6.1,11.4-11.4   c0.6-2.1,1-4.1,1.2-6.5H5.3C5.5,77.9,5.8,79.9,6.5,82z"
        />
        <path
          fill="#FFFFFF"
          d="M5,63.6c0,4.8,0,8.3,0.2,11.2h89.6c0.2-3,0.2-6.5,0.2-11.2v-8.4H5V63.6z"
        />

        {/* Semi-transparent paths */}
        <path fillOpacity={0.29} d="M5,74.8v0.7h0.3c0-0.2,0-0.5-0.1-0.7H5z" />
        <path
          fillOpacity={0.29}
          d="M95,75.5v-0.7h-0.2c0,0.2,0,0.5-0.1,0.7H95z"
        />
        <rect fillOpacity={0.29} height="0.7" width="90" x="5" y="54.5" />
        <path
          fillOpacity={0.29}
          d="M5.3,75.5h89.5c0-0.2,0-0.5,0.1-0.7H5.2C5.2,75,5.3,75.3,5.3,75.5z"
        />

        {/* Gray fill paths */}
        <path
          fill="#AAAAAA"
          d="M72.5,39.5c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.8-0.7-0.8s-0.7,0.3-0.7,0.7C71.8,39.1,72.1,39.5,72.5,39.5z"
        />
        <path
          fill="#AAAAAA"
          d="M75.5,39.5c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.8-0.7-0.8s-0.7,0.3-0.7,0.7C74.8,39.1,75.1,39.5,75.5,39.5z"
        />
        <path
          fill="#AAAAAA"
          d="M66.5,39.5c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.8-0.7-0.8s-0.7,0.3-0.7,0.7C65.8,39.1,66.1,39.5,66.5,39.5z"
        />
        <path
          fill="#AAAAAA"
          d="M78.5,39.5c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.8-0.7-0.8s-0.7,0.3-0.7,0.7C77.8,39.1,78.1,39.5,78.5,39.5z"
        />
        <path
          fill="#AAAAAA"
          d="M69.5,39.5c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.8-0.7-0.8s-0.7,0.3-0.7,0.7C68.8,39.1,69.1,39.5,69.5,39.5z"
        />
        <path
          fill="#AAAAAA"
          d="M63.5,39.5c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.8-0.7-0.8s-0.7,0.3-0.7,0.7C62.8,39.1,63.1,39.5,63.5,39.5z"
        />
        <path
          fill="#AAAAAA"
          d="M81.5,39.5c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.8-0.7-0.8s-0.7,0.3-0.7,0.7C80.8,39.1,81.1,39.5,81.5,39.5z"
        />
        <path
          fill="#AAAAAA"
          d="M90.5,39.5c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.8-0.7-0.8s-0.7,0.3-0.7,0.7C89.8,39.1,90.1,39.5,90.5,39.5z"
        />
        <path
          fill="#AAAAAA"
          d="M60.5,39.5c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.8-0.7-0.8s-0.7,0.3-0.7,0.7C59.8,39.1,60.1,39.5,60.5,39.5z"
        />
        <path
          fill="#AAAAAA"
          d="M93.5,39.5c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.8-0.7-0.8s-0.7,0.3-0.7,0.7C92.8,39.1,93.1,39.5,93.5,39.5z"
        />
        <path
          fill="#AAAAAA"
          d="M84.5,39.5c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.8-0.7-0.8s-0.7,0.3-0.7,0.7C83.8,39.1,84.1,39.5,84.5,39.5z"
        />
        <path
          fill="#AAAAAA"
          d="M87.5,39.5c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.8-0.7-0.8s-0.7,0.3-0.7,0.7C86.8,39.1,87.1,39.5,87.5,39.5z"
        />
        <path
          fill="#AAAAAA"
          d="M54.5,39.5c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.8-0.7-0.8s-0.7,0.3-0.7,0.7C53.8,39.1,54.1,39.5,54.5,39.5z"
        />
        <path
          fill="#AAAAAA"
          d="M18.5,39.5c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.8-0.7-0.8s-0.7,0.3-0.7,0.7C17.8,39.1,18.1,39.5,18.5,39.5z"
        />
        <path
          fill="#AAAAAA"
          d="M21.5,39.5c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.8-0.7-0.8s-0.7,0.3-0.7,0.7C20.8,39.1,21.1,39.5,21.5,39.5z"
        />
        <path
          fill="#AAAAAA"
          d="M57.5,39.5c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.8-0.7-0.8s-0.7,0.3-0.7,0.7C56.8,39.1,57.1,39.5,57.5,39.5z"
        />
        <path
          fill="#AAAAAA"
          d="M15.5,39.5c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.8-0.7-0.8s-0.7,0.3-0.7,0.7C14.8,39.1,15.1,39.5,15.5,39.5z"
        />
        <path
          fill="#AAAAAA"
          d="M6.5,39.5c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.8-0.7-0.8s-0.7,0.3-0.7,0.7C5.8,39.1,6.1,39.5,6.5,39.5z"
        />
        <path
          fill="#AAAAAA"
          d="M27.5,39.5c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.8-0.7-0.8s-0.7,0.3-0.7,0.7C26.8,39.1,27.1,39.5,27.5,39.5z"
        />
        <path
          fill="#AAAAAA"
          d="M12.5,39.5c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.8-0.7-0.8s-0.7,0.3-0.7,0.7C11.8,39.1,12.1,39.5,12.5,39.5z"
        />
        <path
          fill="#AAAAAA"
          d="M9.5,39.5c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.8-0.7-0.8s-0.7,0.3-0.7,0.7C8.8,39.1,9.1,39.5,9.5,39.5z"
        />
        <path
          fill="#AAAAAA"
          d="M24.5,39.5c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.8-0.7-0.8s-0.7,0.3-0.7,0.7C23.8,39.1,24.1,39.5,24.5,39.5z"
        />
        <path
          fill="#AAAAAA"
          d="M45.5,39.5c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.8-0.7-0.8s-0.7,0.3-0.7,0.7C44.8,39.1,45.1,39.5,45.5,39.5z"
        />
        <path
          fill="#AAAAAA"
          d="M48.5,39.5c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.8-0.7-0.8s-0.7,0.3-0.7,0.7C47.8,39.1,48.1,39.5,48.5,39.5z"
        />
        <path
          fill="#AAAAAA"
          d="M30.5,39.5c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.8-0.7-0.8s-0.7,0.3-0.7,0.7C29.8,39.1,30.1,39.5,30.5,39.5z"
        />
        <path
          fill="#AAAAAA"
          d="M51.5,39.5c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.8-0.7-0.8s-0.7,0.3-0.7,0.7C50.8,39.1,51.1,39.5,51.5,39.5z"
        />
        <path
          fill="#AAAAAA"
          d="M42.5,39.5c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.8-0.7-0.8s-0.7,0.3-0.7,0.7C41.8,39.1,42.1,39.5,42.5,39.5z"
        />
        <path
          fill="#AAAAAA"
          d="M33.5,39.5c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.8-0.7-0.8s-0.7,0.3-0.7,0.7C32.8,39.1,33.1,39.5,33.5,39.5z"
        />
        <path
          fill="#AAAAAA"
          d="M36.5,39.5c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.8-0.7-0.8s-0.7,0.3-0.7,0.7C35.8,39.1,36.1,39.5,36.5,39.5z"
        />
        <path
          fill="#AAAAAA"
          d="M39.5,39.5c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.8-0.7-0.8s-0.7,0.3-0.7,0.7C38.8,39.1,39.1,39.5,39.5,39.5z"
        />
      </g>

      {/* Gradient fill path */}
      <path
        fill="url(#SVGID_1_)"
        d="M82,6.5C77.1,5,72.6,5,63.6,5H36.4C27.3,5,22.8,5,18,6.6C12.6,8.5,8.5,12.7,6.5,18C5.2,22.2,5,26.1,5,32.7h90  c0-6.7-0.2-10.6-1.6-14.8C91.5,12.6,87.3,8.4,82,6.5z"
      />
    </svg>
  )
}
